import { useEffect, useState } from 'react';

/**
 * Debounce a value
 * Used when a value may constantly changed in a short period,
 * and return the final stable value after this peroid
 * (e.g. normally used for the value of user input)
 * @param {any} value the value we are goint to debounce
 * @param {int} delay the debounce period in millisecond
 * @returns {any} the debounced value
 */
export const useDebounce = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      clearTimeout(timer);
    }
  }, [value, delay])

  return debouncedValue;
};


// WEBPACK FOOTER //
// ./src/utils/debounce.js